module.exports = __webpack_public_path__ + "img/digital-marketing.9271bec6.webp";